import { render, staticRenderFns } from "./CreateConcept.vue?vue&type=template&id=f4756414&scoped=true&"
import script from "./CreateConcept.vue?vue&type=script&lang=ts&"
export * from "./CreateConcept.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConcept.vue?vue&type=style&index=0&id=f4756414&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4756414",
  null
  
)

export default component.exports